// The small faces that mark who else is on a ticket.

import { cn, initialsOf } from '@/lib/utils';

export interface Viewer {
  userId: string;
  name: string;
}

const MAX_FACES = 3;
const FACE =
  'flex size-5 shrink-0 items-center justify-center rounded-full text-[9px] font-semibold leading-none ring-1 ring-white';
// Lavender first: it is the colour agents already have in the thread.
const TINTS = [
  'bg-lavender-100 text-accent-purple',
  'bg-amber-100 text-amber-800',
  'bg-sky-100 text-sky-800',
  'bg-emerald-100 text-emerald-800',
  'bg-rose-100 text-rose-800',
];

/** By user, not by position: a person keeps their colour on every card and in the banner. */
const tintOf = (userId: string): string => TINTS[(Number(userId) || 0) % TINTS.length]!;

/** Decorative: whoever renders it says who this is in text. */
export function ViewerAvatar({ viewer }: { viewer: Viewer }) {
  return (
    <span className={cn(FACE, tintOf(viewer.userId))} aria-hidden>
      {initialsOf(viewer.name)}
    </span>
  );
}

export function ViewerAvatars({ viewers, className }: { viewers: Viewer[]; className?: string }) {
  if (viewers.length === 0) return null;
  const extra = viewers.length - MAX_FACES;
  return (
    <span className={cn('flex shrink-0 -space-x-1', className)} aria-hidden>
      {viewers.slice(0, MAX_FACES).map((viewer) => (
        <ViewerAvatar key={viewer.userId} viewer={viewer} />
      ))}
      {extra > 0 && <span className={cn(FACE, 'bg-gray-200 text-gray-900')}>+{extra}</span>}
    </span>
  );
}
